import { JsonSerializable } from '../shared/jsonSerializable';
import { User } from '../entity/user';
import { Contact } from '../entity/contact';
import { Address } from '../entity/address';
import { ThirdPartyType } from '../entity/third-party-type';

export class ThirdParty extends JsonSerializable {

  siret: string;
  identity: string;
  ede: string;
  label: string;
  productionKind: string;
  businessName: string;
  isMulti: boolean;
  isActive: boolean;
  contacts: Contact[];
  addresses: Address[];
  parents: ThirdParty[];
  type: ThirdPartyType;
  siteUser: User;

  constructor() {
    super();
    this.siret = null;
    this.identity = null;
    this.ede = null;
    this.label = null;
    this.productionKind = null;
    this.businessName = null;
    this.isMulti = null;
    this.isActive = null;
    this.contacts = new Array<Contact>();
    this.addresses = new Array<Address>();
    this.parents = new Array<ThirdParty>();
    this.type = null;
    this.siteUser = null;
  }

  getDefaultAddress(): Address {
    let defaultAddress: Address = null;
    for (let address of this.addresses) {
      if (address.isDefault) {
        defaultAddress = address;
      }
    }
    if (defaultAddress == null) {
      defaultAddress = new Address();
    }
    return defaultAddress;
  }

  getDefaultContact(): Contact {
    let defaultContact: Contact = null;
    for (let contact of this.contacts) {
      if (contact.isDefault) {
        defaultContact = contact;
      }
    }
    if (defaultContact == null) {
       defaultContact = new Contact();
    }
    return defaultContact;
  }

  fromJSON(jsonObj: Object) {
    if(jsonObj!=null){
      for (var propName in jsonObj) {
        if (this.hasOwnProperty(propName)) {
          if(Array.isArray(jsonObj[propName])){
            for (let i in jsonObj[propName]) {
              if(jsonObj[propName] instanceof Object){
                if (propName == "contacts") {
                  this[propName][i] = new Contact();
                } else if (propName == "addresses") {
                  this[propName][i] = new Address();
                } else if (propName == "parents") {
                  this[propName][i] = new ThirdParty();
                }
                if(this[propName][i] != undefined){
                  this[propName][i].fromJSON(jsonObj[propName][i]);
                }
              } else {
                this[propName][i] = jsonObj[propName][i];
              }
            }
          } else {
            if(jsonObj[propName] instanceof Object){
              if (propName == "type") {
                this[propName] = new ThirdPartyType();
              } else if (propName == "siteUser") {
                this[propName] = new User();
              }
              this[propName].fromJSON(jsonObj[propName]);
            } else {
              this[propName] = jsonObj[propName];
            }
          }
        } else {
          if (propName == "relationsAsChild") {
            for (let i in jsonObj[propName]) {
              this.parents[i] = new ThirdParty();
              this.parents[i].fromJSON(jsonObj[propName][i]['parentThirdParty']);
            }
          }
        }
      }
      if(this.businessName == null || this.businessName.length == 0) {
        this.businessName = jsonObj['label'];
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/entity/third-party.ts